import LoadingOverlay from './LoadingOverlay';

export { withLoading, endLoading } from './LoadingOverlay';
export default LoadingOverlay;
